import axios from "axios";

export const editShipmentApi = async (credintial, lang, cookies , shipment_id) => {
  const token = cookies.__t0ken_amar_management;

  let data = JSON.stringify(credintial);

  let config = {
    method: "put",
    url: `${process.env.REACT_APP_API}/edit-shipment/${shipment_id}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
